import React, { MouseEvent } from "react"

import { useLayerPopupContext } from "@shared/contexts"

import { URL, WOW_MONEY_UNIT_PRICE } from "live/constants"

import Roller from "./Roller"

/** 비로그인 시청자에게 보여줄 배너. 로그인 유도 문구와 룰렛 이벤트 홍보 문구를 롤링으로 번갈아 보여준다 */
const Anonymous = () => {
  const { open } = useLayerPopupContext()

  const handleLogin = (e: MouseEvent) => {
    e.preventDefault()
    open("ANONYMOUS")
  }

  return (
    <Roller>
      <li className="wmRow current">
        <p className="wmLoginTxt">
          혜택까지 챙기는 무료방송, 로그인 시 1시간마다{" "}
          <strong className="wmPoint">
            {WOW_MONEY_UNIT_PRICE.toLocaleString()}
          </strong>
          원
        </p>
        <a
          href="#!"
          className="wmLoginBtn"
          title="로그인하기"
          onClick={handleLogin}
        >
          로그인하기 <span className="wmLoginArrow">&gt;</span>
        </a>
      </li>
      <li className="wmRow next">
        <p className="wmLoginTxt">
          <strong className="wmPoint">매일매일 100% 당첨 룰렛이벤트</strong>도
          참여해보세요!
        </p>
        <a
          href={URL.ROULETTE_EVENT}
          target="_blank"
          rel="noopener noreferrer"
          className="wmLoginBtn"
          title="룰렛이벤트 바로가기"
        >
          바로가기 <span className="wmLoginArrow">&gt;</span>
        </a>
      </li>
    </Roller>
  )
}

export default Anonymous
